import React, { useEffect, useState } from 'react';
import AppRoutes from './routes/Routes';
import { getConfigs, setConfig } from './config';
import { appendInvocaTestModeParam } from './util/invocaTestMode';
import { readBuyflowOverrideFromQuery, buyflowOverrideToConfigValue } from './util/buyflowOverride';
import LanguageSync from './components/common/LanguageSync';

function App() {
  const config = getConfigs();
  const [, setElnkConfigUpdated] = useState(0);

  const setElnkConfig = (key, value) => {
    setConfig(key, value);
    setElnkConfigUpdated(Date.now());
  }

  // Initialize from client-side config settings
  useEffect(() => {
    Object
      .keys(window?._elnkCheckout?.config ?? {})
      .forEach((key) => {
        setConfig(key, window._elnkCheckout.config[key]);
      });

    // QA override must win over server-injected _elnkCheckout.config.BUYFLOW_ENABLED
    const buyflowOverride = readBuyflowOverrideFromQuery();
    const buyflowConfigValue = buyflowOverrideToConfigValue(buyflowOverride);
    if (buyflowConfigValue !== null) {
      setConfig('BUYFLOW_ENABLED', buyflowConfigValue);
    }

    setElnkConfigUpdated(Date.now());
  }, []);

  // Set initial client-side config settings
  useEffect(() => {
    if (!window?._elnkCheckout) {
      window._elnkCheckout = {
        config: {
          ...(window?._elnkCheckout?.config ?? {}),
        },
        setElnkConfig,
      };
    }
  }, []);

  // Redirect to headless checkout if partner request
  useEffect(() => {
    if (window.location.hash === '' && window.location.pathname.startsWith('/p/')) {
      const [, uri] = window.location.href.split('/p/');

      window.location.href = appendInvocaTestModeParam(`${config.HEADLESS_CHECKOUT_BASE_URL}/#/partner/${uri}`);
    }
  }, []);


  return (
    <>
      <LanguageSync />
      <AppRoutes />
    </>
  );
}

export default App;
